module.exports = "/_next/static/images/findus-a463b078c085c82a302a2f4cd5de1bef.svg";